/* eslint-disable import/no-mutable-exports */
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getMessaging, isSupported } from 'firebase/messaging'
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check'

import { settings } from '../../main/configs/settings'

let messaging: ReturnType<typeof getMessaging> | null = null

const app = initializeApp(settings.firebaseConfig)

const db = getFirestore(app)
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(
    settings.reacptchaSiteKey as string,
  ),
  isTokenAutoRefreshEnabled: true,
})

const initializeFirebaseMessaging = async () => {
  const isFirebaseMessagingSupported = await isSupported()

  console.log('isFirebaseMessagingSupported', isFirebaseMessagingSupported)

  if (isFirebaseMessagingSupported) {
    console.log('Initializing Firebase Messaging.')
    messaging = getMessaging(app)
    console.log('Firebase Messaging is initialized.')
  } else {
    console.error('Firebase Messaging is not supported in this environment.')
  }
}

initializeFirebaseMessaging()

export {
  app, messaging, db, appCheck,
}
